export const sleep = (ms: number) => { return new Promise(resolve => setTimeout(resolve, ms)); }
export const downloadFile = (key: string, fieldValue: string) => {
    //  const key = 'start_km_upload'
    if (fieldValue?.toString().length) {
        const [fileExtension, base64] = fieldValue.split('|||')
        openFile({ name: `${key}.${fileExtension}`, base64 })
    }

}
export const createNumericArray = (n: number) => {
    return Array.from({ length: n }, (_, i) => i + 1);
}
export const isDropDownSelected = (key: string, obj: any) => {
    return obj[key] && obj[key]?.toString() !== "0"
}
export const openFile = (file: any) => {
    // Convert Base64 to File
    const fileData = atob(file.base64);
    const arrayBuffer = new ArrayBuffer(fileData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < fileData.length; i++) {
        uint8Array[i] = fileData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: file.type });
    const newFile = new File([blob], file.name, { type: file.type });

    console.log("Converted File:", newFile);

    // Create a download link using Blob URL
    const blobUrl = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // const downloadLink = document.createElement("a");
    // const fileName = file.name;
    // downloadLink.href = `${file.base64}`;
    // downloadLink.download = fileName;
    // downloadLink.click();
    //document.body.removeChild(downloadLink);
}
export const getEmptyUserInfo = () => {
    return {
        user_id: "",
        token: "",
        display_name: "",
        role_id: "",
        role_name: "",
    }
}